/* eslint-disable max-len */
import React from 'react'

function DashboardDetailsShimmer() {
    return (
        <div className='mt-12 w-full flex flex-wrap items-center px-6 animate-pulse mb-6'>
            <div className='w-1/4 px-4'>
                <div className='font-normal text-xs text-[#8E8E8E]'>Number of Products with no NFT</div>
                <div className='mt-2 font-medium text-[#1F1F1F] text-[30px] animate-pulse bg-slate-200 h-[30px]' data-testid="no-nft-value"></div>
            </div>
            <div className='w-1/4 px-4'>
                <div className='font-normal text-xs text-[#8E8E8E]'>Number of Stores</div>
                <div className='mt-2 font-medium text-[#1F1F1F] text-[30px] animate-pulse bg-slate-200 h-[30px]' data-testid="no-carts"></div>
            </div>
            <div className='w-1/4 px-4'>
                <div className='font-normal text-xs text-[#8E8E8E]'>Number of Products Scanned</div>
                <div className='mt-2 font-medium text-[#1F1F1F] text-[30px] animate-pulse bg-slate-200 h-[30px]' data-testid="no-scanned-products"></div>
            </div>
            <div className='w-1/4 px-4'>
                <div className='font-normal text-xs text-[#8E8E8E]'>Number of Products</div>
                <div className='mt-2 font-medium text-[#1F1F1F] text-[30px] animate-pulse bg-slate-200 h-[30px]' data-testid="no-of-products"></div>
            </div>
            <div className='w-1/4  px-4 mt-[60px]'>
                <div className='font-normal text-xs text-[#8E8E8E]'>Number of Orders</div>
                <div className='mt-2 font-medium text-[#1F1F1F] text-[30px] animate-pulse bg-slate-200 h-[30px]' data-testid="no-of-orders"></div>
            </div>
            <div className='w-1/4 mt-[60px] px-4'>
                <div className='font-normal text-xs text-[#8E8E8E]'>Number of Checkouts</div>
                <div className='mt-2 font-medium text-[#1F1F1F] text-[30px] animate-pulse bg-slate-200 h-[30px]' data-testid="online-checkout"></div>
            </div>
            <div className='w-1/4 mt-[60px] px-4'>
                <div className='font-normal text-xs text-[#8E8E8E]'>Number of Carts Cleared</div>
                <div className='mt-2 font-medium text-[#1F1F1F] text-[30px] animate-pulse bg-slate-200 h-[30px]' data-testid="carts-cleared" ></div>
            </div>
            <div className='w-1/4 mt-[60px] px-4'>
                <div className='font-normal text-xs text-[#8E8E8E]'>Number of Carts</div>
                <div className='mt-2 font-medium text-[#1F1F1F] text-[30px] animate-pulse bg-slate-200 h-[30px]' data-testid="crypto-payments"></div>
            </div>
            <div className='w-1/4 mt-[60px] px-4'>
                <div className='font-normal text-xs text-[#8E8E8E]'>Number of Cryptocurrency Payments</div>
                <div className='mt-2 font-medium text-[#1F1F1F] text-[30px] animate-pulse bg-slate-200 h-[30px]' data-testid="crypto-payments"></div>
            </div>
        </div>
    )
}

export default DashboardDetailsShimmer
